import { useIntl } from 'react-intl';
import type { Content } from '@plone/types';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import View from './View';
import Schema from './schema';
import type { BlockDataProps } from './View';

interface EditProps {
  data: BlockDataProps;
  content: Content;
  block: string;
  onChangeBlock: (blockId: string, newData: any) => void;
  selected: boolean;
  blocksConfig: any;
}

const Edit = (props: EditProps) => {
  const { data, onChangeBlock, block, selected, blocksConfig } = props;
  const schema = Schema(useIntl());
  return (
    <>
      <View isEdit data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: any, value: any) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          blocksConfig={blocksConfig}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
